import { RootState } from "../types";

export const requestNumberSelector = (state: RootState) =>
  state.requests.requestNumber;

export const errorRequestNumberSelector = (state: RootState) =>
  state.requests.error;
